import styled from '@emotion/styled';
import React from 'react';
import { animated, config, useTransition } from 'react-spring';
import useMeasure from 'react-use-measure';
import { typography } from '../../styles/typography';
import type { InputSize } from './Input';

export const Label = styled.label<{
  size?: InputSize;
  disabled?: boolean;
  isValid?: boolean;
}>`
  ${({ size }) =>
    size === 'small' ? typography.label : typography.tableNumbers}
  font-weight: 400;
  text-align: ${({ size }) => {
    return size === 'small' ? 'center' : 'left';
  }};
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  transition: color 0.1s ease-in;
`;

export const ErrorLabel = styled(Label)`
  position: relative;
  text-align: right;
  height: 36px;
  line-height: 36px;
  display: block;
`;

interface IProps {
  visible?: boolean;
  id: string;
  errorMessage?: string;
}

export const AnimatedErrorLabel: React.FC<IProps> = ({
  visible = false,
  id,
  errorMessage,
}) => {
  const [innerRef, inner] = useMeasure();
  const errorTransition = useTransition(visible, {
    enter: () => async (next) => {
      await next({ height: inner.height, opacity: 1, overflow: 'hidden' });
    },
    leave: () => async (next) => {
      await next({ opacity: 0, height: 0, overflow: 'hidden' });
    },
    update: { height: inner.height },

    config: { ...config.stiff, clamp: true },
  });
  return errorTransition(
    (style, show) =>
      show && (
        <animated.div style={style}>
          <ErrorLabel id={id} ref={innerRef}>
            {errorMessage}
          </ErrorLabel>
        </animated.div>
      ),
  );
};
